import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  InputGroup,
  Input,
  FormErrorMessage,
  useDisclosure,
  Box,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { onUpdateTrackingNumber } from "../../../api/orders";

export function UpdateTrackingNumber({
  row,
  setOpenLoader,
  fetchData,
  filterQuery,
}) {
  const finalRef = React.useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const currentTrackingNumber = row?.externalId || row?.tracking_number || "";

  const { register, handleSubmit, formState, setValue, watch, reset } = useForm(
    {
      defaultValues: {
        tracking_number: currentTrackingNumber,
      },
    }
  );

  useEffect(() => {
    register("tracking_number", {
      required: "Tracking number is required",
      validate: (value) =>
        value &&
        value.trim().length > 0 &&
        value.trim() !== currentTrackingNumber
          ? true
          : value.trim() === currentTrackingNumber
          ? "New tracking number is the same as the current one"
          : "Invalid tracking number",
    });
    if (isOpen) {
      setValue("tracking_number", currentTrackingNumber);
    }
  }, [isOpen]);

  const { errors } = formState;
  const form = watch();
  const toast = useToast();

  const onCloseModal = () => {
    onClose();
    reset();
    if (fetchData) {
      fetchData(filterQuery);
    }
  };

  const handelSubmit = async (data) => {
    setOpenLoader(true);
    const body = {
      tracking_number: data.tracking_number.trim(),
      order_id: row.orderId,
    };

    const res = await onUpdateTrackingNumber(body, toast);
    if (res) {
      toast({
        status: "success",
        title: "",
        description: "Tracking number updated successfully",
      });
      onCloseModal();
    }
    setOpenLoader(false);
  };

  const onError = (errors) => console.log(errors);

  return (
    <>
      <Box
        display={"flex"}
        alignItems={"center"}
        width={"100%"}
        cursor={"pointer"}
        onClick={onOpen}
      >
        <Text onClick={onOpen}>Update Tracking Number</Text>
      </Box>
      <Modal
        isCentered
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onCloseModal}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Tracking Number</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl isRequired mb="4" isInvalid={!!errors.tracking_number}>
              <FormLabel fontSize={12} fontWeight={"semibold"}>
                Tracking Number
              </FormLabel>
              <InputGroup>
                <Input
                  placeholder="Enter Tracking Number"
                  type="text"
                  value={form["tracking_number"]}
                  onChange={(e) => setValue("tracking_number", e.target.value)}
                />
              </InputGroup>
              <FormErrorMessage>
                {errors.tracking_number?.message}
              </FormErrorMessage>
            </FormControl>
          </ModalBody>
          <ModalFooter gap={4}>
            <Button
              colorScheme="white"
              color={"#3182ce"}
              size="sm"
              onClick={onCloseModal}
            >
              Cancel
            </Button>
            <Button
              size="sm"
              color={"white"}
              colorScheme="blue"
              onClick={handleSubmit(handelSubmit, onError)}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
